class CartNotification extends HTMLElement {
 constructor() {
 super();
 this.notification = document.getElementById('cart-notification');
 }
 renderContents(parsedState) {
 document.getElementById("cart-notification-default").innerHTML="";
 this.productId = parsedState.id;
 this.getSectionsToRender().forEach((section => {
 document.getElementById(section.id).innerHTML =
 this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
 }));
 var dropDownIcon = document.querySelector('#cart-icon-bubble');
 if(dropDownIcon.getAttribute("aria-expanded") == "false")
 {
 dropDownIcon.click();
 }
 }
 getSectionsToRender() {
 return [
 {
 id: 'cart-notification-product',
 },
 {
 id: 'cart-notification-button'
 },
 {
 id: 'cart-icon-bubble'
 }
 ];
 }
 getSectionInnerHTML(html, selector = '.shopify-section') {
 return new DOMParser()
 .parseFromString(html, 'text/html')
 .querySelector(selector).innerHTML;
 }
 handleBodyClick(evt) {
 const target = evt.target;
 if (target !== this.notification && !target.closest('cart-notification')) {
 const disclosure = target.closest('details-disclosure');
 this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
 this.close();
 }
 }
 setActiveElement(element) {
 this.activeElement = element;
 }
}
customElements.define('cart-notification', CartNotification);
